<template>
  <div class="Loading" :class="data?'goster':''">
    <div class="lKutu">
      <i class="el-icon-loading"></i> <span
      v-html="text?text:'Yükleniyor'"></span>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['data', 'text'],
    computed: {
      SayfaYukle() {
        return this.data
      },
    },
    watch: {
      SayfaYukle() {
        if (this.data) $("body").addClass("yukleniyor"); else $("body").removeClass("yukleniyor");
      },
    }
  }
</script>
<style>
  .Loading {
    z-index: -1;
    position: fixed;
    text-align: center;
    /*top: -100px;*/
    opacity: 0;
    left: 50%;
    top: 10%;
    transform: translate(-50%, -50%);
    -webkit-transition: all 0.3s ease;
    transition: all 0.3s ease;
    border-radius: 4px;
    overflow: hidden;
  }


  @-webkit-keyframes AnimationName {
    0% {
      background-position: 0% 50%
    }
    50% {
      background-position: 100% 50%
    }
    100% {
      background-position: 0% 50%
    }
  }

  @-moz-keyframes AnimationName {
    0% {
      background-position: 0% 50%
    }
    50% {
      background-position: 100% 50%
    }
    100% {
      background-position: 0% 50%
    }
  }

  @keyframes AnimationName {
    0% {
      background-position: 0% 50%
    }
    50% {
      background-position: 100% 50%
    }
    100% {
      background-position: 0% 50%
    }
  }

  .Loading .lKutu {
    min-width: 250px;
    background: linear-gradient(50deg, #36b37e, #36b3a4);
    background-size: 400% 400%;

    -webkit-animation: AnimationName 3s ease infinite;
    -moz-animation: AnimationName 3s ease infinite;
    animation: AnimationName 3s ease infinite;
    padding: 10px 20px;
    color: #fff;
    z-index: 2;
    -webkit-transition: all 0.3s ease;
    transition: all 0.3s ease;

  }

  .Loading.goster:after {
    content: '';
    z-index: -1;
    position: fixed;
    right: 0;
    left: 0;
    top: 0;
    bottom: 0;
    background: #fff;
    opacity: 0.4;
  }

  .Loading .lKutu i {
    font-size: 25px;
    position: absolute;
    left: 20px;
    top: 10px;
  }

  .goster {
    /*top: 10px;*/
    z-index: 99999;
    opacity: 1;
  }

</style>



// WEBPACK FOOTER //
// src/components/Doc/Yukleniyor.vue